/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import moment from 'moment';

// import mx from '../../analytic';
import s from './Blog.css';

const messages = defineMessages({
  postedOn: {
    id: 'blog.postedOn',
    defaultMessage: '##Article posted {date}##',
    description: 'Display blog published date',
  },
});

class Blog extends React.Component {
  static propTypes = {
    post: PropTypes.shape({
      id: PropTypes.number.isRequired,
      date: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    }),
  };

  static contextTypes = {
    intl: intlShape,
  };

  static defaultProps = {
    post: null,
  };

  componentDidMount() {
    const {
      post: { title, slug, category },
    } = this.props;
    /* mx.track('#Blog Article Read', {
      Country: category,
      Title: title,
      Slug: slug,
    }); */
  }

  componentDidUpdate() {
    if (process.env.BROWSER && this.grid) {
      this.grid.updateLayout();
    }
  }

  render() {
    if (!this.props.post) {
      return null;
    }
    const {
      post: { feature_image, title, date, content },
    } = this.props;
    // const htmlContent = content.replace(/\r\n|\n|\r/g, '<br />');
    return (
      <div className={s.root}>
        {feature_image && (
          <div
            className={s.featureImage}
            style={{ backgroundImage: `url("${feature_image}")` }}
          />
        )}
        <div className={s.container}>
          <p>{title}</p>

          <div className={s.date}>
            <FormattedMessage
              {...messages.postedOn}
              values={{
                date: moment(date).format('ddd, DD MMM YYYY'),
              }}
            />
          </div>
          <div
            className={s.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Blog);
